<form [formGroup]="qualityManagementSettingsForm" (ngSubmit)="onSubmitQualityManagementSettings()">
  <div formGroupName="groupAutomaticEvaluationsForm">
    <h4>
      {{ 'Settings::AutomaticAssignmentSettings' | abpLocalization }}
    </h4>
    <div class="form-group mt-3">
      <label class="form-label" for="groupEvaluationsBy">
        {{ 'Settings::AutomaticAssignmentGroupByHeader' | abpLocalization }}
      </label>
      <ca-select formControlName="groupEvaluationsBy">
        <ca-option [value]="'Agent'">
          {{ 'Agent' | abpLocalization }}
        </ca-option>
        <ca-option [value]="'Department'">
          {{ 'Department' | abpLocalization }}
        </ca-option>
      </ca-select>
      <small class="form-text text-muted">
        {{ 'Settings::AutomaticAssignmentGroupByExplanation' | abpLocalization }}
      </small>
    </div>

    <div class="form-group mt-3">
      <input
        type="checkbox"
        id="showAutomaticEvaluationScore"
        formControlName="showAutomaticEvaluationScore" />
      <label class="ps-1" for="showAutomaticEvaluationScore">
        {{ 'Settings::ShowAutomaticEvaluationScore' | abpLocalization }}
      </label>
    </div>
    <div class="form-group mt-3">
      <input
        type="checkbox"
        id="automaticEvaluationObjectionEnabled"
        formControlName="automaticEvaluationObjectionEnabled" />
      <label class="ps-1" for="automaticEvaluationObjectionEnabled">
        {{ 'Settings::AutomaticEvaluationObjectionEnabled' | abpLocalization }}
      </label>
    </div>
  </div>

  <div class="mt-3" formGroupName="evaluationSettingsForm">
    <h4>{{ 'Settings::EvaluationSettings' | abpLocalization }}</h4>
    <div class="form-group mt-3">
      <input
        type="checkbox"
        id="allowMultipleEvaluation"
        formControlName="allowMultipleEvaluation" />
      <label class="ps-1" for="allowMultipleEvaluation">
        {{ 'Settings::AllowMultipleEvaluationSetting' | abpLocalization }}
      </label>
      <div>
        <small class="form-text text-muted">
          {{ 'Settings::AllowMultipleEvaluationSettingDescription' | abpLocalization }}
        </small>
      </div>
    </div>
    <div class="form-group mt-3">
      <h4>{{ 'Settings::ObjectionLimitSettings' | abpLocalization }}</h4>
      <label class="form-label" for="groupEvaluationsBy">
        {{ 'Settings::ObjectionLimitSettingsHeader' | abpLocalization }}
      </label>
      <input
        type="number"
        [min]="0"
        [max]="999"
        id="objectionLimit"
        formControlName="objectionLimit"
        class="form-control form-control-sm" />
      <small class="form-text text-muted">
        {{ 'Settings::ObjectionLimitSettingsExplanation' | abpLocalization }}
      </small>
    </div>
  </div>

  <div class="mt-3" formGroupName="calibrationSettingsForm">
    <h4>{{ 'Settings::CalibrationSettings' | abpLocalization }}</h4>
    <div class="form-group mt-3">
      <input
        type="checkbox"
        id="calibrateWithFilledForm"
        formControlName="calibrateWithFilledForm" />
      <label class="ps-1" for="calibrateWithFilledForm">
        {{ 'Settings::CalibrateWithFilledForm' | abpLocalization }}
      </label>
    </div>
  </div>

  <div class="mt-3" formGroupName="evaluationEmailAlertSettingsForm">
    <h4>
      {{ 'Settings::EvaluationEmailAlertSettings' | abpLocalization }}
    </h4>
    <div class="form-group mt-3">
      <label class="form-label">
        {{ 'Settings::EvaluationEmailAlertSettings.Header' | abpLocalization }}
      </label>
    </div>

    <div class="form-group d-flex row">
      <div class="col">
        <label class="fw-bold">
          {{ 'Settings::EvaluationEmailAlertSettings.Period' | abpLocalization }}
        </label>
      </div>

      <div class="col">
        <input type="checkbox" id="hourly" formControlName="hourly" />
        <label class="ps-1" for="hourly">
          {{ 'Settings::EvaluationEmailAlertSettings.Hourly' | abpLocalization }}
        </label>
      </div>
      <div class="col">
        <input type="checkbox" id="daily" formControlName="daily" />
        <label class="ps-1" for="daily">
          {{ 'Settings::EvaluationEmailAlertSettings.Daily' | abpLocalization }}
        </label>
      </div>
      <div class="col">
        <input type="checkbox" id="weekly" formControlName="weekly" />
        <label class="ps-1" for="weekly">
          {{ 'Settings::EvaluationEmailAlertSettings.Weekly' | abpLocalization }}
        </label>
      </div>
      <div class="col">
        <input type="checkbox" id="monthly" formControlName="monthly" />
        <label class="ps-1" for="monthly">
          {{ 'Settings::EvaluationEmailAlertSettings.Monthly' | abpLocalization }}
        </label>
      </div>
      <div class="col-5"></div>
    </div>
  </div>

  <button type="button" type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
